import { useContext, useState } from "react";
import { useSelector } from "react-redux";
import { useFundStoreWalletMutation } from "../../../../hooks/api/mutations/useInventory";
import { cleanObject } from "../../../../helpers";
import { ToastContext } from "../../../../hooks/context";
import { useQueryClient } from "react-query";
import {
  useGetAccountingBanksListConditionally,
  useGetCustomerStoreWallets,
} from "../../../../hooks/api/queries";

const useStoreWalletFund = ({ customerDetails, setIsFundWallet }) => {
  const { storeList } = useSelector((state) => state.profileDetailsReducer);
  const triggerToast = useContext(ToastContext);
  const queryClient = useQueryClient();
  const [fundDetails, setFundDetails] = useState({
    payment_method: "",
    description: "",
    amount: "",
    store_id: "",
    wallet_id: "",
    transfer_amount: "",
    card_amount: "",
    cash_amount: "",
  });
  const currencyCode = storeList?.find(
    (item) => item?.id === fundDetails?.store_id,
  )?.currency_code;
  const fundStoreWallet = useFundStoreWalletMutation();

  const { data: storeWallets, isLoading: isLoadingStoreWallets } =
    useGetCustomerStoreWallets({
      customer_id: customerDetails?.customerId,
    });

  const { data: bankAccount = [], isLoading: isLoadingBankAccountsList } =
    useGetAccountingBanksListConditionally({
      isShowBankAccounts: true,
    });

  const [selectBank, setSelectedBank] = useState(bankAccount?.[0]?.id || "");
  const handleFundWallet = () => {
    fundStoreWallet.mutate(
      cleanObject({
        ...fundDetails,
        ledger_account_id: selectBank,
      }),
      {
        onSuccess: () => {
          triggerToast(
            `A sum of ${currencyCode} ${fundDetails?.amount} has been credited to wallet`,
            "success",
          );
          queryClient.invalidateQueries(["getStoreWalletDetails"]);
          queryClient.invalidateQueries(["getStoreWallets"]);
          queryClient.invalidateQueries(["getStoreWalletTransaction"]);
          setIsFundWallet(null);
        },
      },
    );
  };

  return {
    storeList,
    fundDetails,
    isFundingWallet: fundStoreWallet?.isLoading,
    selectBank,
    setFundDetails,
    handleFundWallet,
    setSelectedBank,
    storeWallets,
    isLoadingStoreWallets,
    bankAccount,
    isLoadingBankAccountsList,
  };
};

export default useStoreWalletFund;
